module.exports = __webpack_public_path__ + "Roboto-Light-webfont.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.eot
// module chunks = 1